import { gql } from '@apollo/client';

export const fetchInvoiceGroupsCountBySoldToAddressNames = gql`
  query fetchInvoiceGroupsCountBySoldToAddressNames(
    $transactionAccountId: String!
    $shipToPartyNames: [String!]!
    $filterOptions: FilterOption
  ) {
    invoiceGroupsCountForShipToPartyNames(
      transactionAccountId: $transactionAccountId
      shipToPartyNames: $shipToPartyNames
      filterOptions: $filterOptions
    ) {
      shipToPartyIds
      shipToPartyName
      totalCount
    }
  }
`;
